import './NotAvailable.css'
import React from 'react';

const NotAvailable = () => {
    return (
        <div>

            <div>
                <img className="img-size" src='https://www.argildx.com/wp-content/uploads/2017/06/Is-a-Misconfigured-%E2%80%9CPage-Not-Found%E2%80%9D-Jeopardizing-Your-Website.jpg' alt="" />
            </div>
            <div>
                <h1 className="text-center py-2">Opps! Page Not Found</h1>
            </div>

        </div>
    );
};

export default NotAvailable;